import { combineEpics } from 'redux-observable';

import fetchBookingHistoryEpic from './epics/fetchBookingHistory';

export default combineEpics(fetchBookingHistoryEpic);
